import axios from 'axios';
import moment from 'moment';

class MitPasswordActivityService {
  constructor() {

  }

  isActivityDateTimeValid(dateTimeString){
    return (moment(dateTimeString, "YYYY-MM-DD HH:mm:ss", true).isValid() === true);
  }
  getActivityDateStringLocal(){
    return moment().local().format('YYYY-MM-DD HH:mm:ss').toString();//default to now
  }
  getActivityDateStringUtc(dateStringLocal){
    return moment(dateStringLocal, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD HH:mm:ss").toString();
  }

  adaptToUIModel(logs){
    for(let x = 0; x < logs.length; x++){
      logs[x].dates_local = {
        createDt: moment(logs[x].createDt).local().format('MM/DD/YYYY h:mm:ss a'),
        finishDt: logs[x].finishDt != null ? moment(logs[x].finishDt).local().format('MM/DD/YYYY h:mm:ss a') : null
      };
      logs[x].data_ui = JSON.stringify(logs[x].data);
    }

    return logs;
  }

  requestGetActivity(paging, options) {
    return new Promise ((resolve, reject) => {

      let url = new URL(window.location.origin+'/api/v1/management/activity');

      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          url.searchParams.append(prop, options[prop]);
        }
      }
      for (let prop in paging) {
        if (paging.hasOwnProperty(prop)) {
          url.searchParams.append(prop, paging[prop]);
        }
      }

      axios.get(url.pathname+url.search)
        .then((response) => {
            this.adaptToUIModel(response.data.logs);
            return resolve(response.data);
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }


}

export default new MitPasswordActivityService();
